(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cata-success"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    // Parse URL parameters
    const params = new URLSearchParams(window.location.search);
    
    // Check if we came from the form (custom params added on submit)
    const name = params.get('name');
    const email = params.get('email');
    const people = params.get('people');
    const pack = params.get('pack');
    const date = params.get('date');

    if (name) {
      document.getElementById('greetingTitle').innerText = '¡Gracias, ' + name + '!';
      document.getElementById('rName').innerText = name;
      if (email) document.getElementById('rEmail').innerText = email;
      if (people) document.getElementById('rPeople').innerText = people;
      
      if (pack) {
        // Format pack name purely for display
        const packNames = {
          'vinos-quesos': 'Vinos y Quesos',
          'vinos-chocolates': 'Vinos y Chocolates',
          'vinos-filloas': 'Vinos y Filloas Rellenas',
          'vinos-cine': 'Vinos con Escenas de Cine',
          'musicalizada': 'Cata Musicalizada',
          'vermuts': 'Cata de Vermuts',
          'tematica': 'Cata Temática',
          'personalizada': 'Cata Personalizada'
        };
        document.getElementById('rPack').innerText = packNames[pack] || pack;
      }

      if (date) {
        document.getElementById('rDate').innerText = date;
        document.getElementById('rDateRow').style.display = 'block';
      }

      // Show the summary box
      document.getElementById('reservationSummary').style.display = 'block';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["catas-gateway"] && !Shopify.designMode) return;
  try {
    
(function() {
  var gw = document.querySelector('[id^="catas-gateway-"]');
  if (!gw) return;
  gw.querySelectorAll('a[href*="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var hash = this.getAttribute('href');
      var anchor = hash.indexOf('#');
      if (anchor === -1) return;
      var id = hash.substring(anchor);
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Quick search — client-side filter */
  (function() {
    var input = document.getElementById('wine-quick-search');
    if (!input) return;

    input.addEventListener('input', function() {
      var term = this.value.toLowerCase().trim();
      var cards = document.querySelectorAll('#wine-product-grid .product-card');
      var visible = 0;

      cards.forEach(function(card) {
        var title = card.getAttribute('data-title') || '';
        var vendor = card.getAttribute('data-vendor') || '';
        var type = card.getAttribute('data-type') || '';
        var tags = card.getAttribute('data-tags') || '';
        var haystack = title + ' ' + vendor + ' ' + type + ' ' + tags;

        if (term === '' || haystack.indexOf(term) !== -1) {
          card.style.display = '';
          visible++;
        } else {
          card.style.display = 'none';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function() {
  var lists = document.querySelectorAll('.faq__list');
  lists.forEach(function(list) {
    list.addEventListener('click', function(e) {
      var btn = e.target.closest('.faq__question');
      if (!btn) return;

      var item = btn.closest('.faq__item');
      var answer = item.querySelector('.faq__answer');
      var expanded = btn.getAttribute('aria-expanded') === 'true';

      // Close all siblings
      list.querySelectorAll('.faq__item').forEach(function(sibling) {
        sibling.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
        sibling.querySelector('.faq__answer').hidden = true;
      });

      // Toggle current
      if (!expanded) {
        btn.setAttribute('aria-expanded', 'true');
        answer.hidden = false;
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["favoritos"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sliders = document.querySelectorAll('.favoritos__slider');
  sliders.forEach(function(slider) {
    var slides = slider.querySelectorAll('.favoritos__slide');
    var dots   = slider.querySelectorAll('.favoritos__dot');
    var prev   = slider.querySelector('.favoritos__btn--prev');
    var next   = slider.querySelector('.favoritos__btn--next');
    var speed  = parseInt(slider.dataset.speed, 10) || 5000;
    var current = 0;
    var timer;

    if (slides.length <= 1) return;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      slides[current].setAttribute('aria-hidden', 'true');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = (index + slides.length) % slides.length;

      slides[current].classList.add('is-active');
      slides[current].setAttribute('aria-hidden', 'false');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function start() {
      clearInterval(timer);
      timer = setInterval(function() { goTo(current + 1); }, speed);
    }

    function reset() {
      clearInterval(timer);
      start();
    }

    if (next) next.addEventListener('click', function() { goTo(current + 1); reset(); });
    if (prev) prev.addEventListener('click', function() { goTo(current - 1); reset(); });

    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { goTo(parseInt(this.dataset.index, 10)); reset(); });
    });

    slider.addEventListener('mouseenter', function() { clearInterval(timer); });
    slider.addEventListener('mouseleave', start);

    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
(function() {
  var section = document.querySelector('[id^="hero-slider-"]');
  if (!section) return;

  var slides = section.querySelectorAll('.hero-slider__slide');
  var dots = section.querySelectorAll('.hero-slider__dot');
  var arrows = section.querySelectorAll('.hero-slider__arrow');
  var count = slides.length;
  if (count < 2) return;

  var current = 0;
  var duration = parseFloat(getComputedStyle(section).getPropertyValue('--slide-duration')) * 1000 || 6000;
  var timer;
  var transitioning = false;

  function goTo(index) {
    if (transitioning || index === current) return;
    transitioning = true;

    slides[current].classList.remove('is-active');
    slides[current].classList.add('is-leaving');

    current = ((index % count) + count) % count;

    slides[current].classList.add('is-active');

    dots.forEach(function(d, i) {
      d.classList.toggle('is-active', i === current);
    });

    setTimeout(function() {
      slides.forEach(function(s) { s.classList.remove('is-leaving'); });
      transitioning = false;
    }, 1200);

    resetTimer();
  }

  function next() { goTo(current + 1); }
  function prev() { goTo(current - 1); }

  function resetTimer() {
    clearInterval(timer);
    timer = setInterval(next, duration);
  }

  arrows.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var dir = parseInt(this.getAttribute('data-dir'));
      goTo(current + dir);
    });
  });

  dots.forEach(function(dot) {
    dot.addEventListener('click', function() {
      goTo(parseInt(this.getAttribute('data-goto')));
    });
  });

  /* Pause on hover */
  section.addEventListener('mouseenter', function() { clearInterval(timer); });
  section.addEventListener('mouseleave', resetTimer);

  /* Touch swipe */
  var touchStartX = 0;
  section.addEventListener('touchstart', function(e) {
    touchStartX = e.changedTouches[0].screenX;
  }, { passive: true });
  section.addEventListener('touchend', function(e) {
    var diff = e.changedTouches[0].screenX - touchStartX;
    if (Math.abs(diff) > 50) {
      diff > 0 ? prev() : next();
    }
  }, { passive: true });

  /* Smooth scroll for anchor links */
  section.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  resetTimer();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  /* Thumbnail gallery */
  document.querySelectorAll('.product-page__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var mainImg = document.getElementById('product-main-image');
      if (mainImg) {
        mainImg.src = this.dataset.imageUrl;
      }
      document.querySelectorAll('.product-page__thumb').forEach(function(t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
